import type { SaleMode, WeightEstimate, ServingEstimate, PortionSize } from '@paulownia/shared/types';
import {
  UnitFields,
  UnitPricedByWeightFields,
  WeightFields,
  WeightEstimatedFields,
  WeightPackagedFields,
} from './sale-mode-fields';

interface SaleModeFieldsProps {
  saleMode: SaleMode;
  price?: number;
  weightEstimate?: WeightEstimate;
  servingEstimate?: ServingEstimate;
  portionSizes?: PortionSize[];
  disclaimer?: string;
  onPriceChange: (price: number | undefined) => void;
  onWeightEstimateChange: (estimate: WeightEstimate | undefined) => void;
  onServingEstimateChange: (estimate: ServingEstimate | undefined) => void;
  onPortionSizesChange: (sizes: PortionSize[]) => void;
  onDisclaimerChange: (disclaimer: string | undefined) => void;
}

export function SaleModeFields({
  saleMode,
  price,
  weightEstimate,
  servingEstimate,
  portionSizes,
  disclaimer,
  onPriceChange,
  onWeightEstimateChange,
  onServingEstimateChange,
  onPortionSizesChange,
  onDisclaimerChange,
}: SaleModeFieldsProps) {
  switch (saleMode) {
    case 'UNIT':
      return <UnitFields price={price} onPriceChange={onPriceChange} />;

    case 'UNIT_PRICED_BY_WEIGHT':
      return (
        <UnitPricedByWeightFields
          price={price}
          weightEstimate={weightEstimate}
          disclaimer={disclaimer}
          onPriceChange={onPriceChange}
          onWeightEstimateChange={onWeightEstimateChange}
          onDisclaimerChange={onDisclaimerChange}
        />
      );

    case 'WEIGHT':
      return <WeightFields price={price} onPriceChange={onPriceChange} />;

    case 'WEIGHT_ESTIMATED':
      return (
        <WeightEstimatedFields
          price={price}
          servingEstimate={servingEstimate}
          disclaimer={disclaimer}
          onPriceChange={onPriceChange}
          onServingEstimateChange={onServingEstimateChange}
          onDisclaimerChange={onDisclaimerChange}
        />
      );

    case 'WEIGHT_PACKAGED':
      return (
        <WeightPackagedFields
          price={price}
          portionSizes={portionSizes}
          onPriceChange={onPriceChange}
          onPortionSizesChange={onPortionSizesChange}
        />
      );

    default:
      return null;
  }
}
